import { useQuery } from '@apollo/client';

import {
  GetCatalogProductViewQuery,
  GetCatalogProductViewQueryVariables,
} from '@notino/shared/definitions/types';

import getProductView from '../../ProductDetailContainer/queries/catalogProductView.graphql';

interface GetProductViewParams {
  catalogId: number;
  productId: number;
  ssrEnabled: boolean;
}

export const useGetProductView = ({
  catalogId,
  productId,
  ssrEnabled,
}: GetProductViewParams) => {
  const { data, loading, error } = useQuery<
    GetCatalogProductViewQuery,
    GetCatalogProductViewQueryVariables
  >(getProductView, {
    ssr: ssrEnabled,
    variables: {
      masterId: String(productId),
      catalogMasterId: String(catalogId),
    },

    errorPolicy: 'all',
  });

  return { data, loading, error };
};
